import { restRequest } from "vrcore-dashboard/dist/utilities";

export const GET_REPORTS = restRequest(
    "VRCORE.JOBPACK_WIDGETS.RELATED_REPORTS_WIDGETS.GET_REPORTS"
);
export const GET_REPORT_TITLES = restRequest(
    "VRCORE.JOBPACK_WIDGETS.RELATED_REPORTS_WIDGET.GET_REPORT_TITLES"
);
export const GET_REGISTERED_USERS = restRequest("VRCORE.JOBPACK_WIDGETS.RELATED_REPORTS_WIDGET.GET_REGISTERED_USERS");

export const SET_REPORT = restRequest("VRCORE.JOBPACK_WIDGETS.RELATED_REPORTS_WIDGET.SET_REPORT");

export const GET_RECIEPTS = restRequest(
    "VRCORE.JOBPACK_WIDGETS.RELATED_REPORTS_WIDGETS.GET_RECIEPTS"
);